import CountryFact from './CountryFact';
import CountryPrice from './CountryPrice';

export default function BudgetItem({
  externalLink,
  category,
  currency,
  priceUsd,
  noBorder,
}) {
  if (!priceUsd) return <></>;
  return (
    <CountryFact
      noBorder={noBorder}
      externalLink={externalLink}
      category={category}
      value={<CountryPrice currency={currency} priceUsd={priceUsd} />}
    />
  );
}
